import { PLATINUM_COLOR } from 'containers/App/constants';
import { Modal } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import styled from 'styled-components';

export const CreativeContainerStyles = styled.div`
  .creative-block-header {
    display: flex;
    justify-content: space-between;
  }

  .creative-id {
    font-weight: bold;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 80%;
    padding-bottom: 10px;

    & > div {
      display: flex;
      align-items: center;
      gap: 2px;
      border-right: 5px solid black;
      padding-inline: 10px;
    }

    .icon {
      cursor: pointer;
    }

    .icon-disabled {
      color: ${PLATINUM_COLOR};
      pointer-events: none;
    }
  }

  .update-container {
    width: 20%;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;

    .label {
      font-weight: bold;
    }

    .button-container {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      align-items: center;
    }
  }

  .bg-info {
    color: black;
  }
`;

export const StyledCarousel = styled(Carousel)`
  .react-multi-carousel-item {
    display: flex;
    align-items: center;
  }

  .asset-loader {
    margin: auto;
  }

  .asset-image,
  .asset-video {
    width: 99%;
  }

  .asset-video {
    height: 100%;
  }

  .asset-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .asset-label {
    font-weight: bold;
    font-size: 0.9rem;
    text-align: center;

    display: flex;
    justify-content: center;
    gap: 10px;
  }
`;

export const StyledPreviewModal = styled(Modal)`
  .modal {
    width: 80vw;
  }
  .modal-body {
    max-height: 80vh;
  }

  .asset-image,
  .asset-video {
    max-width: 99%;
    max-height: 70vh;
  }
`;
